import { RouteConfig } from 'vue-router';
import SwForgotPassword from './components/sw-forgot-password.vue';

export const forgotPasswordRoute: RouteConfig = {
  path: 'forgot-password',
  component: SwForgotPassword,
};
